export default __webpack_public_path__ + "static/avatar-mp-kayi-female-0-v3-cover-09b63c9695090bfd936b3c2188428db3.png";